import React from 'react';
import PropTypes from 'prop-types';
import helpIcon from '../../../assets/images/help_normal.png'
import SMCLink from '../../Simple/SMCLink';
import { makeStyles } from '@mui/styles';
import {getHelpURL} from '../../../conf/Routes';


function HeaderHelp({
    helpId
}) {
    const classes = useStyles();

    return (
        <div className="page-header-container">
            <span className="PageHeaderText">
                <div className="help-icon">
                    {
                        (helpId) ?  
                            (<SMCLink openInNewTab href={getHelpURL(helpId)}>
                                <button title="Help" className={classes.helpButton}>
                                    <img src={helpIcon} alt="help" />
                                </button>
                            </SMCLink>) : ""
                    }
                    {
                        // If has no helpId, return this element without a help link (space is for format)
                        !helpId && <>&nbsp;</>
                    }
                </div>
            </span>
        </div>
    );
}

const useStyles = makeStyles({
    helpButton: {
        border: 0,
        background: 'transparent'
    }
});

HeaderHelp.propTypes = {
    helpId: PropTypes.array
}

export default HeaderHelp;